import { BaseClass } from './base';

export class MonitoringActionProperties {
  constructor(props) {
    this.executions = [];
    this.name = '';
    this.type = '';
    this.typeProperties = {
      emailTo: '',
    };

    Object.assign(this, props);
  }
}

export class MonitoringAction extends BaseClass {
  constructor(props) {
    super();
    this.properties = new MonitoringActionProperties();
    this.entities = {
      executions: {},
    };

    this.type = 'action';
    Object.assign(this, props);
  }
}
